export class ModalBackdropOptions {
    constructor(options) {
        this.animate = true;
        Object.assign(this, options);
    }
}
//# sourceMappingURL=modal-backdrop.options.js.map